import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Action, Mutation } from 'vuex-module-decorators';
import { ISectionMenuItem, ISectionOptionType, ISectionTypes } from '~/types/componentTypes';

@InjectModule({ stateFactory: true }, module)
export default class SectionModule extends InjectVuexModule {
    public SECTIONS: ISectionTypes[] = [
        {
            id: 111,
            sectionTitle: 'Patient',
            selected: false,
            options: [
                {
                    id: 1,
                    title: 'Enroll in Co-Pay Assistance',
                    navTitle: 'Enroll in Co-Pay Assistance',
                    selected: false,
                    menuItems: [
                        // {
                        //     id: 'a',
                        //     title: 'Getting Started',
                        //     route: '/patient/getting-started/',
                        //     completed: false,
                        // },
                        {
                            id: 'b',
                            title: 'Eligibility Questions',
                            route: '/patient/eligibility/',
                            completed: false,
                        },
                        {
                            id: 'c',
                            title: 'Patient Information',
                            route: '/patient/patient-information/',
                            completed: false,
                        },

                    ],
                },
                // {
                //     id: 2,
                //     title: 'Upload Documents (Submit co-pay claims)',
                //     navTitle: 'Upload Documents',
                //     selected: false,
                //     menuItems: [
                //         {
                //             id: 'e',
                //             title: 'Document Upload',
                //             route: '/upload-copay-documents/',
                //             completed: false,
                //         },
                //     ],
                // },
                // {
                //     id: 3,
                //     title: 'E-Consent (Patient Authorization)',
                //     navTitle: 'E-Consent (Patient Authorization)',
                //     selected: false,
                //     menuItems: [
                //         {
                //             id: 'e',
                //             title: 'Patient Information',
                //             route: '/patient/patient-information/',
                //             completed: false,
                //         },
                //         {
                //             id: 'f',
                //             title: 'Patient Authorization',
                //             route: '/patient/patient-authorization/',
                //             completed: false,
                //         },
                //     ],
                // },
                // {
                //     id: 4,
                //     title: 'Request Nurse Injection Training',
                //     navTitle: 'Request Nurse Injection Training',
                //     selected: false,
                //     menuItems: [
                //         {
                //             id: 'g',
                //             title: 'Patient Information',
                //             route: '/patient/patient-information/',
                //             completed: false,
                //         },
                //         {
                //             id: 'h',
                //             title: 'Prescriber Information',
                //             route: '/patient/prescriber-information/',
                //             completed: false,
                //         },
                //         {
                //             id: 'i',
                //             title: 'Patient Authorization',
                //             route: '/patient/patient-authorization/',
                //             completed: false,
                //         },
                //     ],
                // },
                // {
                //     id: 5,
                //     title: 'Request GlatopaJect<sup>®</sup> Device',
                //     navTitle: 'Request Glatopaject<sup>®</sup> Device',
                //     selected: false,
                //     menuItems: [
                //         {
                //             id: 'j',
                //             title: 'Patient Information',
                //             route: '/patient/patient-information/',
                //             completed: false,
                //         },
                //         {
                //             id: 'k',
                //             title: 'Prescriber Information',
                //             route: '/patient/prescriber-information/',
                //             completed: false,
                //         },
                //         {
                //             id: 'l',
                //             title: 'Patient Authorization',
                //             route: '/patient/patient-authorization/',
                //             completed: false,
                //         },
                //     ],
                // },
            ],
        },
        // {
        //     id: 222,
        //     sectionTitle: 'Healthcare Provider',
        //     selected: false,
        //     options: [
        //         // {
        //         //     id: 3,
        //         //     title: 'Enroll Patient in Support Services',
        //         //     navTitle: 'Enroll in Patient Support Services',
        //         //     selected: false,
        //         //     menuItems: [
        //         //         {
        //         //             id: 'm',
        //         //             title: 'Getting Started',
        //         //             route: '/hcp/getting-started/',
        //         //             completed: false,
        //         //         },
        //         //         {
        //         //             id: 'n',
        //         //             title: 'Patient Information',
        //         //             route: '/hcp/patient-information/',
        //         //             completed: false,
        //         //         },
        //         //         {
        //         //             id: 'o',
        //         //             title: 'Health Insurance Information',
        //         //             route: '/hcp/health-insurance-information/',
        //         //             completed: false,
        //         //         },
        //         //         {
        //         //             id: 'p',
        //         //             title: 'Diagnosis Information',
        //         //             route: '/hcp/diagnosis-information',
        //         //             completed: false,
        //         //         },
        //         //         {
        //         //             id: 'q',
        //         //             title: 'Prescriber Information',
        //         //             route: '/hcp/prescriber-information/',
        //         //             completed: false,
        //         //         },
        //         //         {
        //         //             id: 'r',
        //         //             title: 'Pharmacy Information',
        //         //             route: '/hcp/pharmacy-information/',
        //         //             completed: false,
        //         //         },
        //         //     ],
        //         // },
        //         {
        //             id: 3,
        //             title: 'Enroll Patient in Co-Pay Assistance',
        //             navTitle: 'Enroll in Co-Pay Assistance',
        //             selected: false,
        //             menuItems: [
        //                 {
        //                     id: 'f',
        //                     title: 'Getting Started',
        //                     route: '/hcp/getting-started/',
        //                     completed: false,
        //                 },
        //                 {
        //                     id: 'g',
        //                     title: 'Eligibility Questions',
        //                     route: '/hcp/eligibility/',
        //                     completed: false,
        //                 },
        //                 {
        //                     id: 'h',
        //                     title: 'Patient Information',
        //                     route: '/hcp/patient-information/',
        //                     completed: false,
        //                 },
        //             ],
        //         },
        //         {
        //             id: 4,
        //             title: 'Upload Documents (Submit co-pay claims)',
        //             navTitle: 'Upload Documents',
        //             selected: false,
        //             menuItems: [
        //                 {
        //                     id: 'i',
        //                     title: 'Document Upload',
        //                     route: '/upload-copay-documents/',
        //                     completed: false,
        //                 },
        //             ],
        //         },
        //     ],
        // },
        // {
        //     id: 333,
        //     sectionTitle: 'Pharmacy',
        //     selected: false,
        //     options: [
        //         {
        //             id: 9,
        //             title: 'Enroll Patient in Co-Pay Assistance',
        //             navTitle: 'Enroll in Co-Pay Assistance',
        //             selected: false,
        //             menuItems: [
        //                 {
        //                     id: 'v',
        //                     title: 'NCPDP Input',
        //                     route: '/pharmacy/ncpdp/',
        //                     completed: false,
        //                 },
        //                 {
        //                     id: 'w',
        //                     title: 'Eligibility Questions',
        //                     route: '/pharmacy/eligibility/',
        //                     completed: false,
        //                 },
        //                 {
        //                     id: 'x',
        //                     title: 'Patient Information',
        //                     route: '/pharmacy/patient-information/',
        //                     completed: false,
        //                 },
        //             ],
        //         },
        //         {
        //             id: 10,
        //             title: 'Request GlatopaJect<sup>®</sup> Device',
        //             navTitle: 'Request Services',
        //             selected: false,
        //             menuItems: [
        //                 {
        //                     id: 'y',
        //                     title: 'Pharmacy Information',
        //                     route: '/pharmacy/pharmacy-information/',
        //                     completed: false,
        //                 },
        //             ],
        //         },
        //     ],
        // },
    ];
    // eslint-disable-next-line @typescript-eslint/no-inferrable-types
    public isPssFlow: boolean = false;
    public get isPatientPath() {
        const patientPathId = 111;
        return this.SECTIONS.find(path => path.id === patientPathId)?.selected;
    }

    public get isHcpPath() {
        const HcpPathId = 222;
        return this.SECTIONS.find(path => path.id === HcpPathId)?.selected;
    }

    public get isPharmacytPath() {
        const pharmacyPathId = 333;
        return this.SECTIONS.find(path => path.id === pharmacyPathId)?.selected;
    }

    public get isHcpSupportService() {
        const HcpPathId = 6;
        return this.SECTIONS.find(path => path.options.find(hcpPath => hcpPath.id === HcpPathId)?.selected)?.selected;
    }

    public get anyPathSelected() {
        return this.SECTIONS.some(section => section.options.some(option => option.selected));
    }

    public get nothingSelected() {
        return this.SECTIONS.every(section => !section.selected);
    }

    public get activeSection() {
        return this.SECTIONS.map(section => ({
            ...section,
            options: section.options.filter(option => option.selected),
        })).filter(section => section.selected || section.options.length > 0);
    }

    get activeUniqueMenuItems(): ISectionOptionType {
        const uniqueMenuItemsSet = new Set<string>();
        const activeOptions: ISectionOptionType[] = this.SECTIONS.flatMap(section =>
            section.options
                .filter(option => option.selected)
                .map(option => ({
                    ...option,
                    menuItems: option.menuItems.filter(menuItem => {
                        const isUnique = !uniqueMenuItemsSet.has(menuItem.id);
                        if (isUnique) uniqueMenuItemsSet.add(menuItem.id);
                        return isUnique;
                    }),
                }))
                .filter(option => option.menuItems.length > 0)
                .sort((a, b) => (a.id > b.id ? 1 : a.id < b.id ? -1 : 0))
        );
        return activeOptions[0];
    }

    @Mutation
    public resetSelections() {
        this.SECTIONS.forEach(element => {
            element.selected = false;
            element.options.forEach(option => {
                option.selected = false;
                option.menuItems.forEach(menu => {
                    menu.completed = false;
                });
            });
        });
    }

    @Mutation
    public handleSelectionPath({ section, optionIndex }: { section: ISectionTypes; optionIndex: number }) {
        this.SECTIONS.forEach(element => {
            element.selected = false;
            element.options.forEach(option => {
                option.selected = false;
            });
        });
        this.isPssFlow = section.options[optionIndex].navTitle === 'Enroll in Patient Support Services';
        section.options[optionIndex].selected = true;
        section.selected = true;
    }

    @Mutation
    public resetPssFlow() {
        this.isPssFlow = false;
    }

    @Mutation
    public enableSection(section: ISectionTypes) {
        this.SECTIONS.forEach(element => {
            if (element.id !== section.id) {
                element.selected = false;
                element.options.forEach(option => {
                    option.selected = false;
                });
            }
        });
        section.selected = true;
    }

    @Mutation
    public completeMenuItem(menuItem: ISectionMenuItem) {
        menuItem.completed = true;
    }

    @Action
    public nextMenuItem(route: string) {
        const allMenuItemsWithHeading: ISectionOptionType = this.activeUniqueMenuItems;

        // Check if activeUniqueMenuItems is defined and has menuItems
        if (!allMenuItemsWithHeading || !allMenuItemsWithHeading.menuItems) {
            const sections = (this as any).SECTIONS || [];
            const patientSection = sections.find((section: ISectionTypes) => section.id === 111);
            if (patientSection) {
                const eConsentOption = patientSection.options.find((option: ISectionOptionType) => option.id === 3);
                if (eConsentOption && eConsentOption.menuItems) {
                    // Find current route in E-Consent menu items
                    const idx = eConsentOption.menuItems.findIndex((obj: ISectionMenuItem) => obj.route === route);
                    if (idx !== -1 && idx < eConsentOption.menuItems.length) {
                        // Mark current menu item as completed
                        this.context.commit('completeMenuItem', eConsentOption.menuItems[idx]);
                        if (idx < eConsentOption.menuItems.length - 1) {
                            return eConsentOption.menuItems[idx + 1].route;
                        }
                    }
                }
            }

            console.error('Error: Could not find next menu item in E-Consent flow');
            return undefined;
        }

        const idx = allMenuItemsWithHeading.menuItems.findIndex(obj => obj.route === route);
        if (idx !== -1 && idx < allMenuItemsWithHeading.menuItems.length) {
            this.context.commit('completeMenuItem', allMenuItemsWithHeading.menuItems[idx]);
            if (idx < allMenuItemsWithHeading.menuItems.length - 1) {
                return allMenuItemsWithHeading.menuItems[idx + 1].route;
            } else {
                return undefined;
            }
        } else {
            return undefined;
        }
    }

    @Action
    public prevoiusMenuItem(route: string) {
        const allMenuItemsWithHeading: ISectionOptionType = this.activeUniqueMenuItems;

        // Check if activeUniqueMenuItems is defined and has menuItems
        if (!allMenuItemsWithHeading || !allMenuItemsWithHeading.menuItems) {
            // Use this.SECTIONS directly after casting to the proper type
            const sections = (this as any).SECTIONS || [];
            const patientSection = sections.find((section: ISectionTypes) => section.id === 111);
            if (patientSection) {
                const eConsentOption = patientSection.options.find((option: ISectionOptionType) => option.id === 3);
                if (eConsentOption && eConsentOption.menuItems) {
                    // Find current route in E-Consent menu items
                    const idx = eConsentOption.menuItems.findIndex((obj: ISectionMenuItem) => obj.route === route);
                    if (idx > 0) {
                        return eConsentOption.menuItems[idx - 1].route;
                    }
                }
            }

            return '/';
        }

        const idx = allMenuItemsWithHeading.menuItems.findIndex(obj => obj.route === route);
        if (idx > 0) {
            return allMenuItemsWithHeading.menuItems[idx - 1].route;
        } else {
            return '/';
        }
    }
}
